<app-tablelayout
    [data]="students"
    [filterItems]="filterOptions"
    [count]="count"
    [columns]="columns"
    [columnsToRemove]="removeColumn"
    [offset]="25"
    [allowExport]="true"
    exportFileName="school-students"
    [noRecordText]="noStudentText"
    (loadDataEvent)="loadTableData($event)">
</app-tablelayout>
